__turbopack_context__.v({
  "button": "ThemeToggle-module__4R_rJq__button",
  "buttonFull": "ThemeToggle-module__4R_rJq__buttonFull",
  "icon": "ThemeToggle-module__4R_rJq__icon",
  "label": "ThemeToggle-module__4R_rJq__label",
  "srOnly": "ThemeToggle-module__4R_rJq__srOnly",
});
